import { render } from "./ImageDataConfigViewer.vue?vue&type=template&id=5fd258ef&scoped=true&ts=true"
import script from "./ImageDataConfigViewer.vue?vue&type=script&lang=ts"
export * from "./ImageDataConfigViewer.vue?vue&type=script&lang=ts"

import "./ImageDataConfigViewer.vue?vue&type=style&index=0&id=5fd258ef&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fd258ef"]])

export default __exports__